import bnafar from './bnafar'
import cns from './cns'
import ria from './ria'
import erpsaude from './erpsaude'
import rira from './rira'
import esus from './esus'

export default [
    {
        path: 'integracao',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...bnafar,
            ...cns,
            ...ria,
            ...erpsaude,
            ...rira,
            ...esus,
        ],
    },
]